import { render } from "./pastFooter.vue?vue&type=template&id=0a5e2526&ts=true"
import script from "./pastFooter.vue?vue&type=script&lang=ts"
export * from "./pastFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__